import { Widget } from '../../../apiService';
import Vitrine from '../../../Vitrine';

const VitrineWidget = ({ widget, eager }: { widget: Widget<'vitrine'>; eager?: boolean }) => (
  <Vitrine widget={widget} eager={eager} />
);

export default VitrineWidget;
